module.exports = __webpack_public_path__ + "static/media/graph1.d3d2f110.svg";